import EventEmitter from 'events';

const APUSH_DOMAIN = window['apushServerDomain'];
const ONETALK_DOMAIN = window['onetalkServerDomain'];

const DEFAULT_OPTIONS = {
  appId: 'icbu_silkroad',
  tokenUrl: `//${ONETALK_DOMAIN}/apush/getApushToken.htm`,
  port: 80,
  serverDomain: APUSH_DOMAIN
};

export const MessageType = {
  LOGOUT: 10000001,
  MESSAGE_NEW: 20000001,
  MESSAGE_READ_STATUS_CHANGE: 20000002,
  SYS_NOTICE_NEW: 30000001,
  MESSAGE_NEW_SELF: 40000001,
  MESSAGE_REVERT: 20000003,
  MESSAGE_PROCESS_EVENT_CHANGE: 50000001
};

export class WebSocketIO extends EventEmitter {
  constructor(options) {
    super();
    options = Object.assign({}, DEFAULT_OPTIONS, options);
    this.appId = options.appId;
    this.serverDomain = options.serverDomain;
    this.port = options.port;
    this.msgCallback = options.msgCallback || this._msgCb.bind(this);
    this.connectCallback = options.connectCallback || this._connectCb.bind(this);
    this.reconnectCallback = options.reconnectCallback || this._reconnectCb.bind(this);
    this.disconnectCallback = options.disconnectCallback || this._disconnectCb.bind(this);
    this.tokenUrl = options.tokenUrl;
    this.client = null;
  }

  _msgCb(msg) {
    this.emit('msgcallback', msg);
  }

  _connectCb(msg) {
    this.emit('msgconnect', msg);
  }

  _reconnectCb(msg) {
    this.emit('msgreconnect', msg);
  }

  _disconnectCb(msg) {
    this.emit('msgdisconnect', msg);
  }

  createClient() {
    if (!this.client && window['Apush2']) {
      const Apush2 = window['Apush2'];
      Apush2.port = this.port;
      Apush2.serverDomain = this.serverDomain;
      this.client = Apush2.createClient(this.appId, this.tokenUrl, this.msgCallback, null, null, this.connectCallback, this.reconnectCallback, this.disconnectCallback);
    }
    return this.client;
  }
}
